"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MainBeltAsteroids = void 0;
const CardName_1 = require("../../CardName");
const CardRenderer_1 = require("../render/CardRenderer");
const PreludeCard_1 = require("../prelude/PreludeCard");
const Tags_1 = require("../Tags");
const ResourceType_1 = require("../../ResourceType");
const CardRenderDynamicVictoryPoints_1 = require("../render/CardRenderDynamicVictoryPoints");
const DeferredAction_1 = require("../../deferredActions/DeferredAction");
const SelectHowToPayDeferred_1 = require("../../deferredActions/SelectHowToPayDeferred");
const Resources_1 = require("../../Resources");
const SelectCard_1 = require("../../inputs/SelectCard");
const Size_1 = require("../render/Size");
class MainBeltAsteroids extends PreludeCard_1.PreludeCard {
    constructor() {
        super({
            name: CardName_1.CardName.MAIN_BELT_ASTEROIDS,
            tags: [Tags_1.Tags.SPACE],
            resourceType: ResourceType_1.ResourceType.ASTEROID,
            metadata: {
                cardNumber: 'P53',
                renderData: CardRenderer_1.CardRenderer.builder((b) => {
                    b.megacredits(-5);
                    b.text('Pay 5 M€. 1 VP / 2 asteroids here.', Size_1.Size.SMALL, false, false);
                    b.preludeBox('action', (ce) => {
                        ce.vSpace(Size_1.Size.LARGE);
                        ce.action('Add 1 asteroid to ANY CARD.', (eb) => {
                            eb.empty().startAction.asteroids(1);
                        });
                        ce.vSpace();
                        ce.effect('When adding an asteroid here, gain 1 titanium.', (eb) => {
                            eb.asteroids(1).startEffect.titanium(1);
                        });
                        ce.vSpace();
                    });
                }),
                victoryPoints: CardRenderDynamicVictoryPoints_1.CardRenderDynamicVictoryPoints.asteroids(1, 2),
            },
        });
        this.resourceCount = 0;
    }
    canPlay(player) {
        return player.canAfford(5);
    }
    play(player) {
        player.game.defer(new SelectHowToPayDeferred_1.SelectHowToPayDeferred(player, 5, { title: `Select how to pay for ${this.name}` }), DeferredAction_1.Priority.LOSE_RESOURCE_OR_PRODUCTION);
        return undefined;
    }
    canAct() {
        return true;
    }
    action(player) {
        const targets = player.getResourceCards(ResourceType_1.ResourceType.ASTEROID);
        if (targets.length === 1) {
            player.addResourceTo(this, { log: true });
            return undefined;
        }
        return new SelectCard_1.SelectCard('Select card to add asteroid resource', 'Add resource', targets, (foundCards) => {
            player.addResourceTo(foundCards[0], { log: true });
            return undefined;
        });
    }
    getVictoryPoints() {
        return Math.floor(this.resourceCount / 2);
    }
    static onResourceAdded(player, card, count) {
        if (card.name === CardName_1.CardName.MAIN_BELT_ASTEROIDS) {
            player.addResource(Resources_1.Resources.TITANIUM, count, { log: true });
        }
    }
}
exports.MainBeltAsteroids = MainBeltAsteroids;
//# sourceMappingURL=MainBeltAsteroids.js.map